import data from "../../.sourceflow/recruitment_process.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getRecruitmentProcess = (locale = "en") => {
  return new BaseCollection(data, locale).orderBy((i) => parseInt(i["_order"])).getItems();
};
